import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined'
import Avatar from '@mui/material/Avatar'
import { FC } from 'react'
import { GRAY_900 } from 'constants/styling/theme'
import { Nullable } from 'models/helpers'
import SupportAgentIcon from '@mui/icons-material/SupportAgent'
import { useTranslation } from 'react-i18next'

const AGENT_AVATAR_BG = '#F4EFE8'

export const AGENT_BUBBLE_BG = '#F2ECE3'

export type AgentKind = 'assistant' | 'agent'

interface Props {
  kind: AgentKind
  name?: Nullable<string>
}

export const AgentAvatar: FC<Props> = ({ kind, name }) => {
  const { t } = useTranslation(['chat'])
  const agentName = kind === 'agent' ? name?.trim() : undefined
  const label = kind === 'assistant' ? t('chat:conversation.assistant_title') : agentName || t('chat:thread.agent_badge')

  return (
    <Avatar
      role="img"
      aria-label={label}
      title={label}
      sx={{
        width: '3.4rem',
        height: '3.4rem',
        flexShrink: 0,
        backgroundColor: AGENT_AVATAR_BG,
        color: GRAY_900,
      }}
    >
      {kind === 'assistant'
        ? <AutoAwesomeOutlinedIcon sx={{ fontSize: '2rem' }} />
        : agentName
          ? <span style={{ fontSize: '1.4rem', fontWeight: 600 }}>{Array.from(agentName)[0]?.toUpperCase()}</span>
          : <SupportAgentIcon sx={{ fontSize: '2rem' }} />
      }
    </Avatar>
  )
}
